export interface AuthResult {
  user: object;
  token?: string;
  refreshToken?: string;
  googleTokens?: object;
  idTokenPayload?: { email?: string; name?: string; picture?: string };
}

export function storeAuthTokens({ user, token, refreshToken, googleTokens, idTokenPayload }: AuthResult) {
  localStorage.setItem("user", JSON.stringify(user));
  if (token) localStorage.setItem("session", token);
  if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
  if (googleTokens) localStorage.setItem("googleTokens", JSON.stringify(googleTokens));
  if (idTokenPayload?.email) localStorage.setItem("user email", idTokenPayload.email);
  if (idTokenPayload?.name) localStorage.setItem("user name", idTokenPayload.name);
  if (idTokenPayload?.picture) localStorage.setItem("user picture", idTokenPayload.picture);
}
